<div class="section">
  <div class="updateCont">
    <p class="updateMessage">
      This message contains information that can only be displayed by a newer version of the app.
      @if (platform.is('cordova')) {
        <span>Please upgrade below.</span>
      }
    </p>

    <hr />

    <div class="platformChoiceCont">
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-row class="platformRow">
              @if (platform.is('ios')) {
                <ion-button class="platformChoice appleChoice" type="button" fill="clear">
                  <a href="https://apps.apple.com/gb/app/parent-hub/id1048152859">
                    <span class="platformIcon appleIcon">
                      <ion-icon name="logo-apple"></ion-icon>
                    </span>
                    <p class="platformLabel appleLabel">App Store</p>
                  </a>
                </ion-button>
              }

              @if (platform.is('android')) {
                <ion-button
                  class="platformChoice androidChoice"
                  type="button"
                  fill="clear"
                  >
                  <a
                    href="https://play.google.com/store/apps/details?id=uk.co.parenthub.parenthub&hl=en_GB&showAllReviews=true">
                    <span class="platformIcon androidIcon">
                      <ion-icon name="logo-android"></ion-icon>
                    </span>
                    <p class="platformLabel androidLabel">Play Store</p>
                  </a>
                </ion-button>
              }

              @if (!platform.is('cordova')) {
                <span class="platformChoice browserChoice">
                  <span class="platformIcon browserIcon">
                    <ion-icon name="refresh"></ion-icon>
                  </span>
                  <p class="platformLabel browserLabel">Refresh the page</p>
                </span>
              }
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>

  <div class="item-title">{{ item.title }}</div>

  <div class="item-message">
    <app-dynamic-content [content]="item.message"></app-dynamic-content>
  </div>

  <div class="attachment-container">
    @if (item.attachments) {
      <app-attachments
        [attachments]="item.attachments"
        [useImageColumn]="true"
        (openAttachment)="openAttachment.emit($event)"
      (getThumb)="getThumb.emit($event)"></app-attachments>
    }
  </div>

  <div class="sent-on" item-left>
    Sent on {{ item.createdOn | amFromUtc | amLocal | amDateFormat: 'dddd, MMMM Do [at] h:mm a' }}
  </div>
</div>

<div class="section author">
  <app-announcement-publisher [item]="item" (selectStudent)="selectStudent.emit($event)"></app-announcement-publisher>
</div>
